import menuInit from './menu';
import navbarInit from './navbar';
import searchBarInit from './searchbar';

window.onload = async () => {
  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => module.default());
  }
  if (document.getElementsByClassName('gform_wrapper').length) {
    import('./form').then((module) => module.default());
  }
  if (document.getElementsByClassName('vacatures').length) {
    import('./vacature-filter').then((module) => module.default());
  }
  if (document.getElementsByClassName('tabs').length) {
    import('./tabs').then((module) => module.default());
  }

  if (document.getElementsByClassName('scroll-cta').length) {
    import('./scroll').then((module) => module.default());
  }

  if (document.querySelectorAll('[data-srcset]').length) {
    import('./data-srcset').then((module) => module.default());
  }
  if (document.getElementsByClassName('fill-dates').length && document.getElementsByClassName('datelist').length) {
    import('./filldates').then((module) => module.default());
  }
};

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  menuInit();
  navbarInit();
  searchBarInit();
});
